module.exports = __webpack_public_path__ + "img/hp1.51f95430.svg";